import { Schema } from "@effect/schema";
import { BaseError, Usd } from "@silo/types";
import { VercelKV } from "@vercel/kv";
import { Context, identity } from "effect";

export class KvClientError extends BaseError {
  public readonly _tag = "KvClientError";
}

export class KvService extends Context.Tag("KvService")<
  KvService,
  VercelKV
>() {}

export type KvTokenPrice = typeof KvTokenPrice.Type;
export type KvTokenPriceEncoded = typeof KvTokenPrice.Encoded;

export const KvTokenPrice = Schema.transform(
  Schema.Union(Schema.String, Schema.Number),
  Usd,
  {
    decode: String,
    encode: identity,
  }
).annotations({
  identifier: "KvTokenPrice",
});
